/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  customServiceDescription: {
    id: 'customServiceInstance.customServiceDescription',
    defaultMessage: 'Connect your search provider'
  },
  learnMore: {
    id: 'customServiceInstance.learnMore',
    defaultMessage: 'Learn more'
  },
  serviceType: {
    id: 'customServiceInstance.serviceType',
    defaultMessage: 'Service type'
  },
  serverSideSearch: {
    id: 'customServiceInstance.serviderSideSearch',
    defaultMessage: 'By providing credentials'
  },
  clientSideSearch: {
    id: 'customServiceInstance.clientSideSearch',
    defaultMessage: 'Through your client'
  },
  urlLabelText: {
    id: 'customServiceInstance.urlLabelText',
    defaultMessage: 'URL'
  },
  urlPlaceholder: {
    id: 'customServiceInstance.urlPlaceholder',
    defaultMessage: 'exampleUrl.com'
  },
  authTypeLabelText: {
    id: 'customServiceInstance.authTypeLabelText',
    defaultMessage: 'Choose an authentication type'
  },
  usernameLabelText: {
    id: 'customServiceInstance.usernameLabelText',
    defaultMessage: 'Username'
  },
  usernamePlaceholder: {
    id: 'customServiceInstance.usernamePlaceholder',
    defaultMessage: 'exampleUser'
  },
  passwordLabelText: {
    id: 'customServiceInstance.passwordLabelText',
    defaultMessage: 'Password'
  },
  apiKeyLabelText: {
    id: 'customServiceInstance.apiKeyLabelText',
    defaultMessage: 'API key'
  },
  invalidEmptyValueText: {
    id: 'customServiceInstance.invalidEmptyValueText',
    defaultMessage: `Value can't be empty.`
  },
  invalidUrlValueText: {
    id: 'customServiceInstance.invalidUrlValueText',
    defaultMessage: `Value must be a valid url, ex. "https://www.example.com".`
  },
  authTypeAPIkeyText: {
    id: 'customServiceInstance.authTypeAPIkeyText',
    defaultMessage: 'API key'
  },
  authTypeBasicText: {
    id: 'customServiceInstance.authTypeBasicText',
    defaultMessage: 'Basic authentication'
  },
  authTypeNoneText: {
    id: 'customServiceInstance.authTypeNoneText',
    defaultMessage: 'None'
  }
});
